<main id="main-content" class="main-content">
  <h2 class="form-header">{{page()}}. Team & Supporting Documents</h2>

  <mat-card style="margin-bottom: 24px;">
    <div class="title" id="supporting-documents-heading">Supporting Documents</div>

    <div class="table-container" aria-labelledby="supporting-documents-caption supporting-documents-heading">
      <table>
        <caption id="supporting-documents-caption" class="usa-sr-only">
          Supporting Documents.
        </caption>
        <tr class="table-header">
          <th>File Name</th>
          <th>Box Link</th>
        </tr>
        <tr class="table-row">
          <td class="text-cell">Supporting Documents Folder</td>
          @if (report().supporting_documents) {
            <td class="text-cell bold content-cell">
              <a class="standard-text"
                [href]="decodeURI(report().supporting_documents)"
                target="_blank">
                <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                aria-label="Open Link"></fa-icon>
                Open file in Box
              </a>
            </td>
          }
          @if (!report().supporting_documents) {
            <td class="text-cell bold blank-cell">
              --
            </td>
          }
        </tr>
        <tr class="table-row">
          <td class="text-cell">Treatment Recommendations Map</td>
          @if (report().recommendations_map) {
            <td class="text-cell bold content-cell">
              <a class="standard-text"
                [href]="decodeURI(report().recommendations_map)"
                target="_blank">
                <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                aria-label="Open Link"></fa-icon>
                Open file in Box
              </a>
            </td>
          }
          @if (!report().recommendations_map) {
            <td class="text-cell bold blank-cell">
              --
            </td>
          }
        </tr>
        <tr class="table-row">
          <td class="text-cell">Soil Burn Severity Map</td>
          @if (report().burn_severity_map) {
            <td class="text-cell bold content-cell">
              <a class="standard-text"
                [href]="decodeURI(report().burn_severity_map)"
                target="_blank">
                <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                aria-label="Open Link"></fa-icon>
                Open file in Box
              </a>
            </td>
          }
          @if (!report().burn_severity_map) {
            <td class="text-cell bold blank-cell">
              --
            </td>
          }
        </tr>
        <tr class="table-row">
          <td class="text-cell">KMZ package</td>
          @if (report().kmz_submittal_package) {
            <td class="text-cell bold content-cell">
              <a class="standard-text"
                [href]="decodeURI(report().kmz_submittal_package)"
                target="_blank">
                <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                aria-label="Open Link"></fa-icon>
                Open file in Box
              </a>
            </td>
          }
          @if (!report().kmz_submittal_package) {
            <td class="text-cell bold blank-cell">
              --
            </td>
          }
        </tr>
        @for (file of otherLinks; track file) {
          <tr class="table-row">
            <td class="text-cell">{{ file.file_name }}</td>
            <td class="text-cell bold content-cell">
              <a class="standard-text"
                [href]="decodeURI(file.file_link)"
                target="_blank">
                <fa-icon [icon]="faExternalLink" class="fa-regular link-icon"
                aria-label="Open Link"></fa-icon>
                Open link to file
              </a>
            </td>
          </tr>
        }
      </table>
    </div>
  </mat-card>
  <mat-card>
    <div class="title">Team Roster</div>
    <div>
      <div class="text-div">
        <b>Team Leads</b>
      </div>
      <div class="contact-container">
        @for (user of users.data; track user) {
          <div>
            @if (user.role.role_id == 0 || user.role.role_id == 1) {
              <mat-card class="contact-card">
                <div>
                  <div class="user-cell-name">
                    <div class="user-icon">
                      <p>{{user.user.first_name[0]}}</p>
                    </div>
                    <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user.user_id}"
                    class="user-name">{{user.user.first_name + " " + user.user.last_name}}</a>
                  </div>
                  <div class="user-cell-details">
                    <mat-chip>{{ user.role.role }}</mat-chip>
                    <div class="details-number"><mat-icon>phone</mat-icon> {{(user.user.phone_num | phone)
                    ||
                    "--"}}
                  </div>
                  <div class="details-email"><mat-icon>email</mat-icon>{{user.user.email}}</div>
                </div>
              </div>
            </mat-card>
          }
        </div>
      }
    </div>
  </div>
  @if (forestContacts.length > 0) {
    <div>
      <div class="text-div">
        <b>Forest Coordinators</b>
      </div>
      <div class="contact-container">
        @for (user of forestContacts; track user) {
          <mat-card class="contact-card">
            <div>
              <div class="user-cell-name">
                <div class="user-icon">
                  <p>{{user.first_name[0]}}</p>
                </div>
                <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user_id}"
                class="user-name">{{user.first_name + " " + user.last_name}}</a>
              </div>
              <div class="user-cell-details">
                @for (role of user.showRoles; track role) {
                  <mat-chip>{{ role }}</mat-chip>
                }
                <div class="details-number"><mat-icon>phone</mat-icon> {{(user.phone_num | phone) ||
                "--"}}
              </div>
              <div class="details-email"><mat-icon>email</mat-icon>{{user.email}}</div>
              <div class="details-email"><mat-icon>location_on</mat-icon>1{{ user.isFOCO[0] }}</div>
            </div>
          </div>
        </mat-card>
      }
    </div>
  </div>
}

<div class="text-div" id="all-team-members-and-skills-heading">
  <b>All Team Members and Skills</b>
</div>
<table mat-table [dataSource]="users" class="center" aria-hidden="false"
  aria-labelledby="all-team-members-and-skills-caption all-team-members-and-skills-heading"
  >
  <caption id="all-team-members-and-skills-caption" class="usa-sr-only">
    All Team Members and Skills.
  </caption>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>

    <td class="user-cell" mat-cell *matCellDef="let user">
      <div>
        <div class="user-cell-name">
          <div class="user-icon">
            <p>{{user.user.first_name[0]}}</p>
          </div>
          <a [routerLink]="['/user']" [queryParams]="{user_id: user?.user.user_id}"
          class="user-name">{{user.user.first_name + " " + user.user.last_name}}</a>
        </div>
        <div class="user-cell-details">
          <div class="details-email"><mat-icon>email</mat-icon>{{user.user.email}}</div>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>Role</th>
    <td mat-cell *matCellDef="let user" [style.background-color]="user.isSelected ? '#FFF5E1' : 'white'">
      @if (user.role) {
        <mat-chip class="chip">{{user.role.role}}</mat-chip>
      } @else {
        --
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="skills">
    <th mat-header-cell *matHeaderCellDef>Skills</th>
    <td mat-cell *matCellDef="let user" [style.background-color]="user.isSelected ? '#FFF5E1' : 'white'">
      @if (user.skills.length != 0) {
        <div>
          @for (skill of user.skills; track skill) {
            <mat-chip class="chip">
              {{ skill.other_skill ?? skill.skill.text }}
            </mat-chip>
          }
        </div>
      } @else {
        --
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="3">
      @if (pageLoaded) {
        <div class="no-data">
          <div class="no-data-icon">
            <mat-icon class="no-data-icon1">search</mat-icon>
            <fa-icon [icon]="faUsers" class="no-data-icon2"></fa-icon>
          </div>
          <div class="no-data-title">No users available</div>
          <p>There are no users in this roster yet.</p>
        </div>
      }
    </td>
  </tr>
</table>
</mat-card>
</main>
